import { render } from "./IsaacLethalLeague.vue?vue&type=template&id=15a109ba&scoped=true"
import script from "./IsaacLethalLeague.vue?vue&type=script&lang=js"
export * from "./IsaacLethalLeague.vue?vue&type=script&lang=js"

import "./IsaacLethalLeague.vue?vue&type=style&index=0&id=15a109ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a109ba"]])

export default __exports__